import React from 'react';
import { PhoneValidationForm } from 'components';
import { useHistory, useLocation } from 'react-router-dom';
import { ROUTES } from 'routes';
import { useApp } from 'providers';
import { usePageTracking } from 'hooks';
import { TRACKING_PAGES } from 'api';

export const PhoneValidationPage: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const { user } = useApp();
  const { nationalPhoneNumber, internationalPhoneNumber, requestId, zipCode, lineType } = location.state as {
    internationalPhoneNumber?: string;
    nationalPhoneNumber?: string;
    requestId?: string;
    zipCode?: string;
    lineType?: number;
  };

  usePageTracking(TRACKING_PAGES.VALIDATION_PART);

  if (user!.isPro) {
    history.replace(ROUTES.vehiclePrice);
  }
  if (!nationalPhoneNumber || !internationalPhoneNumber || !requestId || !zipCode || lineType === undefined) {
    history.replace(ROUTES.contactInformation);
  }

  return (
    <div>
      <PhoneValidationForm
        internationalPhoneNumber={internationalPhoneNumber!}
        nationalPhoneNumber={nationalPhoneNumber!}
        requestId={requestId!}
        zipCode={zipCode!}
        lineType={lineType!}
      />
    </div>
  );
};
